import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryImporterModal`

export default defineMessages({
  importerTitle: {
    id: `${scope}.importerTitle`,
    defaultMessage: 'Budgets',
  },
  budgetsImporterModalTitle: {
    id: `${scope}.budgetsImporterModalTitle`,
    defaultMessage: 'Import Budgets',
  },
})
